import { render, staticRenderFns } from "./CockpitLabelComponent.vue?vue&type=template&id=c7a5aa00&scoped=true"
import script from "./CockpitLabelComponent.vue?vue&type=script&lang=js"
export * from "./CockpitLabelComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a5aa00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7a5aa00')) {
      api.createRecord('c7a5aa00', component.options)
    } else {
      api.reload('c7a5aa00', component.options)
    }
    module.hot.accept("./CockpitLabelComponent.vue?vue&type=template&id=c7a5aa00&scoped=true", function () {
      api.rerender('c7a5aa00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/cockpitFormCompontents/style-components/CockpitLabelComponent.vue"
export default component.exports